import React, { useState } from "react";

const ThemeContext = React.createContext({
  mode: "dark",
  setMode: () => {},
});

export const useThemeContext = () => React.useContext(ThemeContext);

export const ContextProvider = (props) => {
  const persistentMode = localStorage.getItem("mode");
  const [themeMode, setThemeMode] = useState(persistentMode || "dark");

  const handleTheme = (theme) => {
    setThemeMode(theme);
    localStorage.setItem("mode", theme);
  };

  React.useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    if (themeMode === "dark") {
      root.classList.add("dark");
      body.classList.add("dark");
      body.classList.remove("light");
    } else {
      root.classList.remove("dark");
      body.classList.add("light");
      body.classList.remove("dark");
    }
  }, [themeMode]);

  return (
    <ThemeContext.Provider value={{ mode: themeMode, setMode: handleTheme }}>
      {props.children}
    </ThemeContext.Provider>
  );
};
